import { Button, Typography } from "@mui/material";
import { FileIcon } from "components";
import { ArrowRight, ArrowDropDown, ArrowRightAlt, AddCircleOutline } from "@mui/icons-material";
type IProps = {
    group: any;
    openGroups: any;
    toggleGroup: any;
    addVersion: any;
};

export default function GroupRenderer(props: IProps) {
    const { group, openGroups, toggleGroup, addVersion } = props;
    const info: any = group.id.split("-");
    const projectId: string = info[0];
    const id: string = info[1];
    return (
        <div key={"group-" + group.id} onClick={() => toggleGroup(group)}>
            {group.root && (
                <Button style={{ margin: 0, padding: 0, paddingRight: 5, marginLeft: 12 * group.level }}>
                    {openGroups[projectId][id] ? <ArrowDropDown /> : <ArrowRight />}
                    <FileIcon icon={group.icon} />
                    {group.title}
                </Button>
            )}
            {!group.root && !group.version && (
                <Button style={{ margin: 0, padding: 0, paddingRight: 5, marginLeft: 12 * group.level }}>
                    <ArrowRightAlt style={{ visibility: "hidden" }} />
                    <FileIcon icon={group.icon} />
                    {group.title}
                </Button>
            )}
            {!group.root && group.version && (
                <div style={{ whiteSpace: "nowrap", verticalAlign: "center" }}>
                    <Typography style={{ margin: 0, padding: 0, marginTop: 3, marginLeft: 12 * group.level + 55 }}>
                        Versions
                        <Button
                            size="small"
                            style={{ position: "absolute", marginTop: -3, right: 2, height: 30 }}
                            onClick={(evt) => addVersion(group)}
                        >
                            <AddCircleOutline />
                        </Button>
                    </Typography>
                </div>
            )}
        </div>
    );
}
